import { auth } from './firebase';

export const CRM_FUNCTIONS_URL = 'https://us-central1-lctf-projects.cloudfunctions.net';

/** fetch() a Cloud Function with the signed-in user's ID token. */
export async function crmAuthedFetch(pathOrUrl: string, init: RequestInit = {}): Promise<Response> {
  const user = auth.currentUser;
  if (!user || user.isAnonymous) {
    throw new Error('Sign in required');
  }
  const token = await user.getIdToken();
  const url = pathOrUrl.startsWith('http') ? pathOrUrl : `${CRM_FUNCTIONS_URL}/${pathOrUrl.replace(/^\//, '')}`;
  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${token}`);
  if (init.body != null && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  return fetch(url, { ...init, headers });
}
